module.exports = __webpack_public_path__ + "img/bannerx.b19196e3.jpg";